<!-- 神回复页面 -->
<template>
<div class="brilliant_reply">
    <Header />
    <div class="banner" ref="banner">
        <div class="pc"><img class="blk-img" src="https://media6.imgyb.xyz/media/v1/image/2e17f3fcda036fcf15f3d0a9d5460641.png" alt=""></div>
        <div class="media"><img src="https://media1.imgyb.xyz/media/v1/image/5e38c546d43c0d5a4a527ad3a6e831ea.png" alt=""></div>
    </div>
    <div class="post-list">
        <GodReplyItem v-for="item in list" :key="item.id" :post="item" />
        <div class="loading-style" v-if="hasMore && listLoading"><i class="el-icon-loading"></i> 加载中</div>
    </div>
    
    <CssFooter />
    <LeftShare style="left:50%"  v-show="showFunc" />
</div>
</template>
<script>
import { throttle } from 'throttle-debounce';
import Header from '@/components/header/header.vue'
import GodReplyItem from './reply-item.vue'
import { isScrollToPageBottom } from '@/utils/utils';
import CssFooter from '@/components/css-footer.vue'
import LeftShare from '@/components/left-share.vue'
export default {
    name:'BrilliantReply',
    components:{Header,GodReplyItem,CssFooter,LeftShare},
    data(){
        return {
            params:{
                offset:1,
                size:5
            },
            list:[],
            pageComplete:false,
            hasMore:true,
            showFunc:false,//显示功能区
            listLoading:false
        }
    },
    created(){
        this.getList();
    },
    methods:{
        async getList(){
            this.listLoading = true;
            let result = await this.$axios.post('/bbs/v1/get/good/comment/list',this.params);
            this.pageComplete = true;
            this.listLoading = false;
            if( result.code == 0 ){
          
                if( this.params.offset == 1 ){
                    this.list = [];
                }
                this.list = this.list.concat(result.data.items);
                this.hasMore = this.list.length != result.data.itemTotal;
                
            }
        },
        pageScroll: throttle(300, function () {
            if( isScrollToPageBottom() && this.pageComplete && this.hasMore && !this.listLoading ){
                this.params.offset ++;
                this.getList();
            }
             
            let banner = this.$refs['banner'].scrollHeight;
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            if( top>banner-100){
                this.showFunc = true;
            }else{
                this.showFunc = false;
            }
 
            /* const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            const offsetTop = this.$refs.tab.offsetTop;
            this.tabFixed = scrollTop >= offsetTop; */
        }),
    },
    mounted() {
        window.addEventListener('scroll', this.pageScroll);

        this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('scroll', this.pageScroll);
        });
    },
}
</script>
<style lang="less" scoped>
@import '~@/assets/css/base-util.css';
.brilliant_reply{
    background: #f8f8f8;
    .pc{background: url(https://media2.imgyb.xyz/media/v1/image/6f68da934820c35ef455da3152aa05ff.png) no-repeat center top;}
}
.post-list{
    background: #f8f8f8; border-radius: 10px; margin-top: -10px; overflow: hidden; position: relative; overflow: hidden;
}
.loading-style{display: flex; margin-bottom: 20px; color: #999; justify-content: center ; align-items: center; font-size: 12px;
    i{margin-right: 5px;}
}
</style>